
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Les meilleures agences Google Ads en France - Top 2026",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez le classement 2026 des 15 meilleures agences Google Ads en France. Comparez leurs points forts et choisissez le partenaire idéal pour optimiser vos campagnes et augmenter votre ROI.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Les meilleures agences Google Ads en France - Top 2026",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez le classement 2026 des 15 meilleures agences Google Ads en France. Comparez leurs points forts et choisissez le partenaire idéal pour optimiser vos campagnes et augmenter votre ROI.",
        },
      ],
    };
  },
};
